export default {
  admin: {
    self: 'ادمین',
    info: 'اطلاعات پایه'
  },
  financial: {
    self: 'مالی',
    coupon: {
      self: 'کوپن',
      create: 'ایجاد کوپن',
      delete: 'حذف کوپن',
      get: 'دریافت کوپن',
      update: 'بروزرسانی کوپن'
    },
    'payment-config': 'روش پرداخت',
    payment: {
      self: 'پرداخت',
      create: 'ایجاد پرداخت',
      delete: 'حذف پرداخت',
      edit: 'ویرایش پرداخت',
      get: 'دریافت پرداخت',
      update: 'بروزرسانی پرداخت',
      export: 'خروجی پرداخت',
      verify: 'تایید پرداخت'
    }
  },
  identity: {
    self: 'identity',
    endpoints: 'endpoints',
    permissions: 'دسترسی ها',
    realms: 'پروژه ها',
    roles: 'نقش ها',
    userSessions: 'جلسات کاربر'
  },
  'user-management': {
    self: 'مدیریت کاربران',
    'confirm-mobile-email': 'تایید شماره موبایل و ایمیل',
    'confirm-mobile': 'تایید شماره موبایل',
    'confirm-email': 'تایید ایمیل',
    create: 'ایجاد کاربر',
    edit: 'ویرایش کاربر',
    import: 'وارد کردن کاربر',
    roles: 'نقش ها',
    suspend: 'تعلیق کاربر',
    users: {
      self: 'کاربر',
      delete: 'حذف کاربر'
    }
  }
}
